import React, { useContext, useState } from 'react';
import { Dropdown, Grid, Header, Icon, Popup } from 'semantic-ui-react';

import Avatar from 'react-avatar';

import Controls from './Controls';
import SocialMedia from 'shared/SocialMedia';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ConversionControls from './ConversionControls';
import { ClippedContent, CloseableContent, ConfirmationPrompt, Modal, SelectionsModal, USER_PERMISSIONS, PRODUCT_PERMISSIONS, STATUS_TYPES, Notification } from 'dyl-components';
import { ProfileName } from './ProfileName';
import { JobTitle } from './JobTitle';
import StagesSection from './StagesSection';
import { FAVORITE_TYPE } from 'shared/constants/FAVORITE_TYPE';
import { ProfileFavoriteIcon } from 'shared/ProfileFavoriteIcon';
import SubControls from "../Account/SubControls";
import { QuoteBuilderContext } from 'shared/context/QuoteBuilderProvider';
import UnlinkPopupForm from 'shared/UnlinkPopupForm';
import QuoteBuilderModal from 'shared/modals/QuoteBuilderModal';
import contactActions from 'actions/contact';
import ChangeModulePipelineForm from './ChangeModulePipelineForm';
import sequenceTasksActions from 'actions/sequence_tasks';
import AddAccountModal from 'shared/modals/AddAccountModal';
import FullScreenModalPopUp from 'shared/FullScreenModalPopUp';
import LinkExistingAccountForm from './LinkExistingAccountForm';
import RestrictedView from 'shared/RestrictedView';
import { ArchivedRecordsContext } from 'shared/context/ArchivedRecordsProvider';
import archiveAction from 'actions/archive';
import { PhoneUtil } from 'utils';
import contactsActions from 'actions/contacts';

const modalCategories = [
    {
        selections: [
            { key: 'BusinessAccount', text: 'Business Account', icon: 'fa-solid fa-building' },
            { key: 'HouseholdAccount', text: 'Household Account', icon: 'fa-solid fa-house-chimney-blank' }
        ]
    }
];

const AddModuleRecordsModalContent = ({ activeContent, onClose, contact_id, refreshFromLinking, onDirtyChange }) => {
    if (activeContent === 'BusinessAccount' || activeContent === 'HouseholdAccount') {
        return (
            <AddAccountModal
                account_type={activeContent === 'BusinessAccount' ? 'business' : 'household'}
                refreshFromLinking={refreshFromLinking}
                contactIdToLink={contact_id}
                onClose={onClose}
                onDirtyChange={onDirtyChange}
            />
        );
    }
    return null;
}

function copy(text) {
    return (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(text);
    };
}

export const ProfileHeader = (({
    name,
    breadcrumbs,
    isInHotlist,

    isSidePanelOpen,
    id,

    onHotlistToggle,
}) => {
    const dispatch = useDispatch();
    const {
        parent_account,
        current_stage,
        contactIsAssociatedWithCustomerPipeline,
        account_stage,
        isCustomerAccount,
        isReadingCategories,
        canChangePipeline,
        master_source,
        secondary_source,
        module_custom_data,
        campaign_converted,
        current_pipeline_category,
        account_id,
        primary_contact_id,
        assignees,
        selectedSequenceId,
        selectedSequenceName,
        isReadingSequenceContactTasks,
        pipeline_id,
        isDialerRunning
    } = useSelector((state) => {
        const { master_source, secondary_source, campaign_converted } =
            state.contact.current_stage || {};
        return {
            parent_account: state.contact.account,
            current_stage: state.contact.current_stage,
            contactIsAssociatedWithCustomerPipeline:
                state.contact.account?.pipeline_person_id ===
                Number(state.contact.contact_id),
            account_stage:
                state.contact.current_stage?.account_stage || "contact",
            isCustomerAccount: state.contact.account.has_customer,
            isReadingCategories: state.pipeline.isReadingCategories,
            canChangePipeline: state.pipeline.categories?.length > 1,
            campaign_converted:
                campaign_converted &&
                Object.keys(campaign_converted).length > 1 &&
                Boolean(campaign_converted.id) &&
                Boolean(campaign_converted.name)
                    ? campaign_converted.id
                    : null,
            account_id: state.contact.account_id,
            primary_contact_id: state.contact.account.primary_contact_id,
            secondary_source: secondary_source?.id || null,
            current_pipeline_category: state.contact.current_stage?.pipeline_category_id,
            pipeline_id: state.contact.current_stage?.pipeline_id,
            master_source,
            assignees: state.contact.contact.assignees,
            selectedSequenceId: state.sequence_tasks.selectedSequenceId,
            selectedSequenceName: state.sequence_tasks.selectedSequenceName,
            isReadingSequenceContactTasks: state.sequence_tasks.isReadingSequenceContactTasks,
            isDialerRunning: PhoneUtil.isDialerRunning(state.officeView.dialer),
        };
    });

    const navigate = useNavigate()
    const { account_type, name: title, id: parent_account_id } = parent_account || {};

    const [fieldBeingEdited, setFieldBeingEdited] = useState(null);

    const onEdit = (field_name) => {
        setFieldBeingEdited(field_name);
    }

    const onCancelEdit = () => {
        setFieldBeingEdited(null);
    }

    const isEditing = (field_name) => {
        return field_name === fieldBeingEdited;
    }

    const popupRef = React.createRef();
    const { contact_id } = useParams();
    const isPrimaryContact = isCustomerAccount && (primary_contact_id === Number(contact_id)); 
    const { onOpenAddProducts } = useContext(QuoteBuilderContext);
    const [isUnlinkAccountPopupOpen, setUnlinkAccountPopupOpen] = useState(false);
    const [isModulesModalOpen, setIsModulesModalOpen] = useState(false);
    const [isLinkAccountModalOpen, setIsLinkAccountModalOpen] = useState(false);
    const [isFormDirty, setIsFormDirty] = useState(false);
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const [activeContent, setActiveContent] = useState('selection');
    const [openForm, setOpenForm] = useState(null);
    const [isPipelineFormModified, setIsPipelineFormModified] = useState(false);
    const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
    const onCloseForm = () => {
        setOpenForm(null);
        setIsPipelineFormModified(false);
    };

    const closeModal = () => {
        setActiveContent("selection");
        setIsModulesModalOpen(false);
    };

    const closeLinkAccountModal = () => {
        setIsLinkAccountModalOpen(false);
    };

    const refreshDialerInfo = () => {
        if (isDialerRunning) {
            dispatch(contactsActions.dialerViewLookup(contact_id));
        }
    }

    const refreshFromLinking = () => {
        refreshDialerInfo();
        return dispatch(contactActions.readContact(contact_id));
    };

    const archiveDisabled = (isPrimaryContact || account_stage === "customer" || isReadingSequenceContactTasks);

    const contactDropdownItems = [
        ...(parent_account_id
            ? [
                <RestrictedView userPermission={USER_PERMISSIONS.CONTACTS_EDIT} type="disabled" assignmentIds={[(assignees?.owner_id || 0), (assignees?.coowner_id || 0)]} userRestrict>
                    <Dropdown.Item
                        key="unlink-account"
                        onClick={() => setUnlinkAccountPopupOpen(true)}
                        icon={<Icon className="fas fa-diagram-nested" />}
                        content="Unlink Account"
                        disabled={isPrimaryContact || account_stage !== "contact"}
                    />
                </RestrictedView>,
              ]
            : [
                <RestrictedView userPermission={USER_PERMISSIONS.ACCOUNT_ADD} productPermission={PRODUCT_PERMISSIONS.RECORDS} type="disabled">
                    <Dropdown.Item
                        key="link-new-account"
                        onClick={() => setIsModulesModalOpen(true)}
                        icon={<Icon className="fas fa-diagram-nested" />}
                        content="Link New Account"
                    />
                </RestrictedView>,
                <RestrictedView userPermission={USER_PERMISSIONS.CONTACTS_EDIT} type="disabled" assignmentIds={[(assignees?.owner_id || 0), (assignees?.coowner_id || 0)]} userRestrict>
                    <Dropdown.Item
                        key="link-existing-account"
                        onClick={() => setIsLinkAccountModalOpen(true)}
                        icon={<Icon className="fas fa-diagram-nested" />}
                        content="Link Existing Account"
                    />
                </RestrictedView>,
              ]),

        ...(account_stage === "lead"
            ? [
                  <Dropdown.Item
                      key="change-pipeline"
                      disabled={isReadingCategories || !canChangePipeline}
                      icon={
                          <Icon
                              className={`fa-solid ${
                                  isReadingCategories
                                      ? "fa-circle-notch"
                                      : "fa-filters"
                              }`}
                              loading={isReadingCategories}
                          />
                      }
                      content="Change Pipeline"
                      onClick={() => setOpenForm("change-pipeline")}
                  />,
              ]
            : []),

        ...(account_stage !== "opportunity"
            ? [
                  <Dropdown.Item
                      key="product-catalog"
                      onClick={onOpenAddProducts}
                      icon={<Icon className="fas fa-box" />}
                      content="Product Catalog"
                  />,
              ]
            : []),
        <RestrictedView userPermission={USER_PERMISSIONS.CONTACTS_DELETE} type="disabled" assignmentIds={[(assignees?.owner_id || 0), (assignees?.coowner_id || 0)]} userRestrict>
            {!!archiveDisabled ? (
                <Popup
                    content={account_stage === "customer" ? "Customer pipeline applied" : isPrimaryContact ?  "Primary contact for customer" : "Unable to archive"}
                    position="left center"
                    inverted
                    on={'hover'}
                    trigger={
                            <Dropdown.Item 
                                className={`contact-archive-${
                                    !!archiveDisabled ? "disable" : ""
                                }`} 
                                icon={<Icon className="fas fa-archive" />}
                                content="Archive"
                                key="archive"
                        />
                    }
                />
            ) : (
                <Dropdown.Item
                    key="archive"
                    onClick={() => setIsArchivePopupOpen(true)}
                    icon={<Icon className="fas fa-archive" />}
                    content="Archive"
                />
            )}
        </RestrictedView>
    ];
    const { isArchivedView } = useContext(ArchivedRecordsContext);

    const onArchiveContactConfirm = async () => {
        try {
            await dispatch(archiveAction.archiveRecords(undefined,{
                account_id: null,
                contacts: [ {
                    contact_id: id,
                    sequence_id: selectedSequenceId,
                    sequence_name: selectedSequenceName,
                }],
                opportunity_id: account_stage === "opportunity" ? pipeline_id : null,                
            }));
            navigate("/")
            Notification.alert('Successfully archived contact!', STATUS_TYPES.SUCCESS, true);
        } catch (error) {
            Notification.alert(
                "Failed to archive contact",
                STATUS_TYPES.ERROR
            );
        }
    }
    return (
        <React.Fragment>
            <div style={{ paddingBottom: "0.5em" }}>
                {breadcrumbs}
            </div>
            <Grid>
                <Grid.Row columns='equal' verticalAlign='middle'>
                    <Grid.Column width={!isArchivedView ? 6 : 16}>
                        <Grid columns='equal' verticalAlign='middle'>
                            <Grid.Column className='ProfileHeader__avatarContainer' width={isSidePanelOpen ? 3 : 2} textAlign='center' style={{ padding: '1em 0 1em 0' }}>
                                <Avatar
                                    size='5em'
                                    round
                                    maxInitials={2}
                                    name={name}
                                />
                                <SocialMedia />
                            </Grid.Column>
                            <Grid.Column className='ProfileHeader__nameColumn'>
                                <ProfileName isEditing={isEditing('name')} onEdit={() => { onEdit('name') }} onCancelEdit={onCancelEdit} refreshDialerInfo={refreshDialerInfo} />
                                <Grid className='ProfileHeader__businessContainer' columns={'equal'} verticalAlign='middle'>
                                    {
                                        title && (
                                            <Grid.Column width={5}>
                                                <ClippedContent>
                                                    <span>
                                                        <Icon className={`fas ${account_type === 'business' ? 'fa-building' : 'fa-solid fa-house-chimney-blank'}`} />
                                                        {isArchivedView ? title : <Link to={`/account/${parent_account_id}`} target="_blank">
                                                            {title}
                                                        </Link>}
                                                    </span>
                                                </ClippedContent>
                                            </Grid.Column>
                                        )
                                    }
                                    <Grid.Column {...(!isEditing('job_title') ? { width: 5 } : {})}>
                                        <JobTitle isEditing={isEditing('job_title')} onEdit={() => { onEdit('job_title') }} onCancelEdit={onCancelEdit} refreshDialerInfo={refreshDialerInfo} />
                                    </Grid.Column>
                                </Grid>
                                <div className={`ProfileHeader__leftContainer ${isArchivedView ? 'ProfileHeader_margin' : ''}`}>
                                    <span><Icon className={`fas fa-user`} />Contact</span>
                                    <div className='ProfileHeader__iconsContainer'>
                                        <ProfileFavoriteIcon id={id} type={FAVORITE_TYPE.CONTACT} />
                                        <div className='ProfileHeader__iconsBox' onClick={!isArchivedView ? onHotlistToggle : undefined}>
                                            <div className='ProfileHeader__iconOverlay' />
                                            <Icon link disabled={isArchivedView} className={`${isInHotlist ? "fa-solid fa-fire-flame-curved" : "fa-solid fa-fire-flame"}  ProfileHeader__icon${isInHotlist ? '--red' : '--grey'}`} />
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    ID: {isArchivedView ? id : <Popup
                                        trigger={<a href='#?' role="button" tabIndex="0" onClick={copy(id)}>{id} <Icon className='fas fa-copy' /></a>}
                                        content='Copied!'
                                        on='click'
                                        closeOnTriggerMouseLeave
                                        position='bottom center'
                                        inverted />}
                                </div>
                            </Grid.Column>
                        </Grid>
                    </Grid.Column>
                    {!isArchivedView ? 
                        current_stage?.account_stage && (
                            <Grid.Column width={6}>
                                <StagesSection id={id} />
                            </Grid.Column>
                        )
                    : null}
                   {!isArchivedView && <Grid.Column verticalAlign='middle' textAlign='right'>
                        <Grid columns='equal' verticalAlign='top' textAlign='left'>
                            {!contactIsAssociatedWithCustomerPipeline && !current_stage?.account_stage ? <Grid.Column width={isSidePanelOpen ? 11 : 12} textAlign='right'> <ConversionControls /> </Grid.Column> : <Grid.Column width={isSidePanelOpen ? 5 : 7} textAlign='right'></Grid.Column>}

                            <Grid.Column textAlign='left' >

                                <Controls popupRef={popupRef} />

                                <SubControls popupRef={popupRef} dropdownItems={contactDropdownItems} />
                            </Grid.Column>
                        </Grid>
                    </Grid.Column>}

                </Grid.Row >
            </Grid >
            <Popup
                open={openForm === 'change-pipeline'}
                position='bottom right'
                context={popupRef}
                onClose={onCloseForm}
                content={(
                    <>
                        <Header color='primary'>
                            Change Pipeline
                        </Header>
                        <CloseableContent onClose={onCloseForm}>
                            <ChangeModulePipelineForm
                                contact_id={contact_id}
                                onClose={onCloseForm}
                                refresh={() => { 
                                    dispatch(contactActions.readContact(contact_id)); 
                                    dispatch(sequenceTasksActions.readContactTasks(contact_id)); 
                                    refreshDialerInfo();
                                }}
                                current_pipeline_category={current_pipeline_category}
                                account_stage={account_stage}
                                account_id={parent_account_id}
                                campaign_converted={campaign_converted}
                                custom_data={module_custom_data}
                                master_source={master_source}
                                secondary_source={secondary_source}
                            />
                        </CloseableContent>
                    </>
                )}
                closeOnDocumentClick={!isPipelineFormModified}
            />
            <SelectionsModal
                selectionHeader='Add New'
                categories={modalCategories}
                ToRender={AddModuleRecordsModalContent}
                contentModalSize={activeContent => {
                    if (activeContent === 'selection') {
                        return 'tiny'
                    }
                    if (activeContent === 'BusinessAccount') {
                        return 'big';
                    }
                    return null;
                }}
                open={isModulesModalOpen}
                toRenderProps={{
                    contact_id: Number(contact_id),
                    refreshFromLinking,
                    onDirtyChange: (dirty) => setIsFormDirty(dirty)
                }}
                onClose={() => {
                    isFormDirty
                        ? setIsConfirmationOpen(true)
                        : closeModal();
                }}
                activeContent={activeContent}
                setActiveContent={setActiveContent}
            />
            <Modal open={isLinkAccountModalOpen} onClose={closeLinkAccountModal}>
                <LinkExistingAccountForm
                    contactIdToLink={Number(contact_id)}
                    refreshFromLinking={refreshFromLinking}
                    onClose={closeLinkAccountModal}
                />
            </Modal>
             <UnlinkPopupForm
                isUnlinkAccountPopupOpen={isUnlinkAccountPopupOpen}
                unlinkAccountPopupRef={popupRef}
                setUnlinkAccountPopupOpen={setUnlinkAccountPopupOpen}
                account_id={account_id}
                contact_id={Number(contact_id)}
                unlinkContact
                refresh={() => {
                    refreshFromLinking();
                    refreshDialerInfo();
                    setUnlinkAccountPopupOpen(false);
                }}
            />
            <QuoteBuilderModal 
                account_id={account_id}
            />
             <FullScreenModalPopUp
                header={"Changes not saved"}
                subheader={"Are you sure you want to exit?"}
                isOpen={isConfirmationOpen}
                onConfirm={() => {
                    closeModal()
                    setIsConfirmationOpen(false);
                    setIsFormDirty(false)
                }}
                onFormClose={() => setIsConfirmationOpen(false)}
                closeIcon={false}
            />
            <Popup
                open={isArchivePopupOpen}
                position={`bottom right`}
                context={popupRef}
                onClose={() => setIsArchivePopupOpen(false)}
                content={(<ConfirmationPrompt
                    header={<div style={{ paddingTop: '1em', marginBottom: '5px' }}>Are you sure?</div>}
                    subheader={
                        <div style={{ marginBottom: '-1em' }}>
                           Archive closes/removes all activities associated with this record.
                        </div>
                    }
                    onConfirm={onArchiveContactConfirm}
                    onCancel={() => { setIsArchivePopupOpen(false) }}
                />)}
            />
        </React.Fragment >
    );
});
